import { XeroAuthConnectRequestSchema } from '@vy/api-definition';
import type { oz } from '@vy/utils';
import type { Control } from 'react-hook-form';

export const XeroRegisterFormSchema = XeroAuthConnectRequestSchema;

export type XeroRegisterFormValues = oz.infer<typeof XeroRegisterFormSchema>;
export type XeroRegisterFormControl = Control<XeroRegisterFormValues>;
